import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";

import Sidebar from "./Sidebar";
import logo from '../assets/logo_1.png';

const AdminDashboard: React.FC = () => {
  const autologinUrl = localStorage.getItem("autologinUrl") || "";
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  if (!token) {
    navigate("/");
    return null;
  }

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Container fluid style={{ height: "100vh", display: "flex", padding: 0 }}>

      <Sidebar onLogout={handleLogout} />
      <div style={{ flex: 1, overflow: "hidden" }}>
        {autologinUrl ?
          <iframe
            src={autologinUrl}
            title="Metricool AutoIn"
            width="100%"
            height="100%"
            frameBorder="0"
            loading="lazy"
            allowFullScreen
          />
          :
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            backgroundColor: '#f8f9fa'
          }}>
            <img
              src={logo}
              alt="Logo"
              style={{
                maxWidth: '1000px',
                maxHeight: '1000px',
                objectFit: 'contain'
              }}
            />
          </div>


        }
      </div>

    </Container>
  );
};

export default AdminDashboard;